import * as React from 'react';

const ProjectTitle = (props) => (
	<div className='title-container'>
		<h1>{props.title}</h1>
	</div>
);

export default ProjectTitle;
